module.exports = __webpack_public_path__ + "templates/cart-success.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cart/templates/cart-success.html
// module id = OpKI
// module chunks = 1